import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=871c64c2"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('871c64c2')) {
      api.createRecord('871c64c2', component.options)
    } else {
      api.reload('871c64c2', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=871c64c2", function () {
      api.rerender('871c64c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/certificados/Sidebar.vue"
export default component.exports